module.exports = {
    fichasData: () => {
        return[
            {
                "Apache RR 310": {
                    "Thumb":require("./../UI/fichasThumbs/RR310.webp"),
                    "Ficha":require("./../UI/fichas/AYUDAVENTAS RR310.pdf")
                },
                "Neo NX 110": {
                    "Thumb":require("./../UI/fichasThumbs/Neo.webp"),
                    "Ficha":require("./../UI/fichas/Catálogo_tvs_neonx_110.pdf")
                },
                "Ntorq 125": {
                    "Thumb":require("./../UI/fichasThumbs/ntorque.webp"),
                    "Ficha":require("./../UI/fichas/TVS_Ntorq_125_catalogo.pdf")
                },
                "Ntorq 125 Racing": {
                    "Thumb":require("./../UI/fichasThumbs/NtorqueRacing.webp"),
                    "Ficha":require("./../UI/fichas/tvs_Ntorq_rt_fi_catalogo.pdf")
                },
                "Ntorq 125 fi": {
                    "Thumb":require("./../UI/fichasThumbs/NtorqueFI.webp"),
                    "Ficha":require("./../UI/fichas/Catálogo_tvs_ntorq_125_racing.pdf")
                },
                "Sport 100 KLS": {
                    "Thumb":require("./../UI/fichasThumbs/100KLS.webp"),
                    "Ficha":require("./../UI/fichas/TVS Sport 100 KLS catalogo 2021.pdf")
                },
                "Stryker": {
                    "Thumb":require("./../UI/fichasThumbs/Stryker.webp"),
                    "Ficha":require("./../UI/fichas/TVS Stryker 125 catalogo 2021.pdf")
                },
                "Max 125": {
                    "Thumb":require("./../UI/fichasThumbs/Max.webp"),
                    "Ficha":require("./../UI/fichas/TVS_Max_125_catalogo.pdf")
                },
                "Raider 125": {
                    "Thumb":require("./../UI/fichasThumbs/Raider.webp"),
                    "Ficha":require("./../UI/fichas/CIRCULAR RAIDER.pdf")
                },
                "Apache 160 2V": {
                    "Thumb":require("./../UI/fichasThumbs/160_2.webp"),
                    "Ficha":require("./../UI/fichas/160_2V.pdf")
                },
                "Apache 160 4V": {
                    "Thumb":require("./../UI/fichasThumbs/RTR1604V.webp"),
                    "Ficha":require("./../UI/fichas/Apache 160_4V.pdf")
                },
                "Apache 180 2V": {
                    "Thumb":require("./../UI/fichasThumbs/180_2V.webp"),
                    "Ficha":require("./../UI/fichas/180_2V.pdf")
                },
                "Apache 200 2V": {
                    "Thumb":require("./../UI/fichasThumbs/RTR200.webp"),
                    "Ficha":require("./../UI/fichas/Apache 200_4V.pdf")
                },
                "Apache 200 fi": {
                    "Thumb":require("./../UI/fichasThumbs/RTR200FI.webp"),
                    "Ficha":require("./../UI/fichas/Apache 200_FI.pdf")
                },
                "Motocarro King Basico": {
                    "Thumb":require("./../UI/fichasThumbs/RR310.webp"),
                    "Ficha":require("./../UI/fichas/TVS_King_gs+_catalogo.pdf")
                },
                "Motocarro King Carpa Especial": {
                    "Thumb":require("./../UI/fichasThumbs/RR310.webp"),
                    "Ficha":require("./../UI/fichas/TVS_King_gs+_catalogo.pdf")
                },
                "Motocarro King Carpa Full": {
                    "Thumb":require("./../UI/fichasThumbs/RR310.webp"),
                    "Ficha":require("./../UI/fichas/TVS_King_gs+_catalogo.pdf")
                },
                "Sport 100 ELS": {
                    "Thumb":require("./../UI/fichasThumbs/100ELS.webp"),
                    "Ficha":require("./../UI/fichas/TVS Sport 100 ELS catalogo 2021.pdf")
                }
            }
        ] 
    }
}